const isValidName = (str) => {
  return /^[a-zA-Z-,](\s{0,1}[a-zA-Z-, ])*[^\s]$/.test(str);
};

const isValidPhone = (str) => {
  return /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(str);
};

const isValidEmail = (str) => {
  return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(str);
};
export { isValidName, isValidPhone, isValidEmail };
